package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWere_having_some_trouble_connecting_to_your_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/were_having_some_trouble_connecting_to_your_server.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/were-having-some-trouble-connecting-to-your-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Were_having_some_trouble_connecting_to_your_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("we-re-having-some-trouble-connecting-to-your-server") }) {
        org.jetbrains.compose.web.dom.Text("We're having some trouble connecting to your server")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This error usually indicates that there is a network issue originating either on the server’s end or your end.")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If the issue originates on the server’s end, all you can do is wait patiently until the node your server is running on becomes reachable again. There is no ETA for when this will happen, and all you can do is wait for it to be fixed automatically or manually.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If the issue originates on your machine, you can try using another browser or using your browser in incognito mode. If this does not fix the issue, it is usually related to a VPN causing conflicts with page loading. This is most likely the case if you are running on a premium node and no issues have been reported.")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Node transfers are only possible once the server is reachable again, only if there is still a reason for a transfer, and only if you are a premium user.")
        }
    }
}
